/**
 * Selection Tool
 *
 * Handles object selection and cursor interaction for measurements, planes, surfaces, and boxes.
 * Uses BaseTool's event system — events arrive directly from DOM listeners.
 */

import { BaseTool } from '../../BaseTool';
import { Utils } from '../../../utils';
import { getHoveredSelectable, dispatchSelection } from '../modules/selection/selectionHelper';

export class SelectionPersonaTool extends BaseTool {
  readonly name = 'selection';

  protected onEnable(): void {
    // No setup needed — orbit controls are the default and nothing in the
    // persona tool system changes them.
  }

  protected onDisable(): void {
    Utils.changeCursor('default');
  }

  public onMouseMove(_event: MouseEvent): void {
    if (this.viewer.inputHandler.selectionDisabled) return;

    const hovered = getHoveredSelectable(this.viewer);

    // Do not override forced-mode icons (e.g. orbit-control-specific cursors)
    if (this.viewer.orbitControls.forcedMode) return;

    Utils.changeCursor(hovered ? 'pointer' : 'default');
  }

  public onClick(event: MouseEvent): void {
    if (this.viewer.inputHandler.selectionDisabled) return;

    dispatchSelection(this.viewer, event.ctrlKey || event.metaKey);
  }
}
